import createOpenApiFetchClient, {} from 'openapi-fetch';
import { normalizeBaseUrl } from './config.js';
/**
 * Creates the typed client. A thin wrapper on purpose: it adds configuration
 * and nothing else, so the whole client stays a few kilobytes and there is no
 * generator runtime in the bundle (ADR 0001).
 *
 * This is also the reason no consumer calls `fetch` directly: the wrapper is
 * the single place where the base URL, the tenant-carrying headers and the
 * generated types meet.
 */
export function createCountdownApiClient(options) {
    const { baseUrl, fetch, headers } = options;
    return createOpenApiFetchClient({
        baseUrl: normalizeBaseUrl(baseUrl),
        ...(fetch === undefined ? {} : { fetch }),
        ...(headers === undefined ? {} : { headers }),
    });
}
//# sourceMappingURL=client.js.map